import React, { useState }              from 'react';
import { FlexAlign, FlexJustify, Size } from '../../types';
import { FlexItem }                     from './FlexItem';
import { StyledContainer }              from './StyledContainer';
import { List }                         from 'semantic-ui-react';

import { CorvalVersionNumber }          from '../components/product/CorvalVersionNumber';
import { CorvalTermsAndConditionsLink } from '../components/product/CorvalTermsAndConditionsLink';
import { CorvalPrivacyPolicyLink }      from '../components/product/CorvalPrivacyPolicyLink';
import { CorvalCopyright }              from '../components/product/CorvalCopyright';
import { Flexbox }                      from './Flexbox';
import { CorvalBranchName }             from "@src/views/components/product/CorvalBranchName";
import { ENVIRONMENT_IS_PRODUCTION }    from "@src/constants";

const defaultProps = {};

const PageFooter = () => {
	
	return (
		
		<Flexbox align={ FlexAlign.CENTER } justify={ FlexJustify.END } className={ 'container--fill-area' }>
			<FlexItem noGrow>
				<StyledContainer padding={ [ Size.XS, Size.LG ] }>
					<List inverted horizontal size={ 'tiny' } divided className={ 'text--colored-lt-screen-50' }>
						{/*<List.Item><CorvalTermsAndConditionsLink showPopup={ false }/></List.Item>*/ }
						<List.Item><CorvalCopyright/></List.Item>
						<List.Item><CorvalVersionNumber/></List.Item>
						{ !ENVIRONMENT_IS_PRODUCTION && <List.Item><CorvalBranchName/></List.Item> }
						<List.Item><CorvalPrivacyPolicyLink showPopup={ false }/></List.Item>
					</List>
				</StyledContainer>
			</FlexItem>
		</Flexbox>
	);
};

PageFooter.defaultProps = defaultProps;

export { PageFooter }
